import { Space } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { AmountField } from '~/components';
import { LocationIcon, PersonOutlineIcon, PhonePortraitOutlineIcon } from '~/img';
import { Amount, Transaction } from '~/types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Cell = ({ children }: any): JSX.Element => {
  return children;
};

interface ColoredAmountProps {
  amount: Amount | undefined;
}

const ColoredAmount: FC<ColoredAmountProps> = (props) => {
  const { amount } = props;
  return (
    <AmountField
      amount={amount}
      className={Number(amount?.value) > 0 ? `status-color__ACTIVE` : ''}
    />
  );
};

interface DescriptionProps {
  record: Transaction;
  className?: string;
}

const Description: FC<DescriptionProps> = (props) => {
  const { record, className } = props;

  const terminal = record.details?.terminal;
  const location = record.details?.location;
  const employee = record.details?.employee;

  const referenceId = record?.details?.referenceId;
  const referenceIdString = Array.isArray(referenceId)
    ? referenceId
        .map((ref) => ref.value)
        .filter(Boolean)
        .join(' | ')
    : '';

  return (
    <Space direction="vertical" size={4} className={className}>
      {record.description && <div>{record.description}</div>}
      {(terminal || location || employee) && (
        <Space direction="horizontal" size={16} className="Description-IconText">
          {record.details?.terminal && (
            <IconText icon={<PhonePortraitOutlineIcon />} text={record.details?.terminal.label} />
          )}
          {record.details?.location && (
            <IconText icon={<LocationIcon />} text={record.details?.location.name} />
          )}
          {record.details?.employee && (
            <IconText icon={<PersonOutlineIcon />} text={record.details?.employee.name} />
          )}
        </Space>
      )}
      {Array.isArray(referenceId) && referenceId?.length > 0 && referenceIdString && (
        <div># {referenceIdString}</div>
      )}
    </Space>
  );
};

interface IconTextProp {
  icon: JSX.Element;
  text: string | undefined;
}

const IconText: FC<IconTextProp> = (props) => {
  const { icon, text } = props;
  return (
    <Space direction="horizontal" size={4}>
      {icon}
      <div>{text}</div>
    </Space>
  );
};

Cell.ColoredAmount = ColoredAmount;
Cell.Description = styled(Description)`
  .Description-IconText {
    font-size: 12px;
  }
`;

export default Cell;
